import { WrappedFieldProps } from 'redux-form';

import AddressInput, { Address } from 'dashboard/components/AddressInput';
import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import FormError from 'dashboard/components/FormControls/FormError';
import FormGroup from 'dashboard/layouts/FormLayout/FormGroup';
import { CountryCode } from 'lib/constants/locales';
import FormControlProps from 'lib/interfaces/FormControlProps';

export interface AddressInputFieldProps extends FormControlProps, WrappedFieldProps {
  id?: string;
  className?: string;
  label?: string;
  disabled?: boolean;
  cols?: 1 | 2 | 4;
  countryCode?: CountryCode;
}

const AddressInputField = ({
  id,
  className,
  label,
  disabled,
  countryCode,
  input,
  cols,
  meta: { error, submitFailed, touched },
}: AddressInputFieldProps) => {
  const hasError = !!(error && (submitFailed || touched));

  const onChange = (newValue: Address) => {
    input.onChange({ ...input.value, ...newValue });
  };

  return (
    <FormGroup className={className}>
      {label && <FormControlLabel htmlFor={`${id}--address`}>{label}</FormControlLabel>}
      <AddressInput
        id={id}
        name={input.name}
        value={input.value}
        disabled={disabled}
        countryCode={countryCode}
        cols={cols}
        hasError={hasError}
        onChange={onChange}
      />
      {hasError && <FormError>{error}</FormError>}
    </FormGroup>
  );
};

export default AddressInputField;
